import { Formik, Form, Field, ErrorMessage } from "formik";
import { addUser } from "../API/ApiService";



export default function FormComponent() {

    function validate(values) {
        const errors = {}
        if (!values.email.includes("@")) {
            errors.email = "Enter a valid email."
        }
        if (values.ward < 1 || values.ward > 50) {
            errors.ward = "Enter a valid ward."
        }
        if (values.zone < 1 || values.zone > 32) {
            errors.zone = "Enter a valid zone."
        }
        return errors;
    }

    function onSubmit(values, {resetForm}) {

        const user = {email: values.email, ward: Number(values.ward), zone: Number(values.zone), confirmed: false}

        if (values.company) {
            console.log("Values.company = true")
            return;
        }
        addUser(user)
        resetForm()
    }

    return (
        <div className="formbox">
        
            <div className="signup"><div>Sign up</div></div>

            <Formik
                initialValues={{email: "", ward: 1, zone: 1}}
                validate={validate}
                onSubmit={onSubmit}
                validateOnBlur={false}
                validateOnChange={false}>

            { () => (
                <Form className="innerform">
                    <ErrorMessage name="email" component="div" />
                    <ErrorMessage name="ward" component="div" />
                    <ErrorMessage name="zone" component="div" />

                <div className="email">
                    <label>Email address: </label>
                    <Field className="formemail" data-dashlane-disabled-on-field="true" data-form-type="other"
                    name="email" type="email"
                    placeholder="you@example.com"
                    ></Field>
                    
                </div>
                <div className="ward">
                    <label>Ward: </label>
                    <Field className="formward"
                    name="ward" type="number"
                    min={1}
                    max={50}
                    data-dashlane-disabled-on-field="true"
                    
                    ></Field>
                    
                </div>
                <div className="zone">
                    <label>Zone: </label>
                    <Field className="formzone"
                    name="zone" type="number"
                    min={1}
                    max={32}
                    data-dashlane-disabled-on-field="true"
                    
                    ></Field>
                    

                </div>
                    <Field type="text" name="company" autoComplete="off" style={{display: 'none'}}></Field>
                <div className="submitform">
                    <button type="submit" className="submitbutton">Submit</button>
                </div>
                <div className="verifywarning">
                    <p>Important: You must verify your email by clicking the link in the verification email in order to receive notifications.</p></div>
                </Form> ) }
            </Formik>
        </div>

    );

}

